export interface GalleryProps {
  items: string[];
  onGalleryItemClick?: (url?) => void;
  settings?: {
    thumbnails?: boolean;
    fullScreen?: boolean;
    dots?: boolean;
    dotsColor?: string;
    imageHeight?: number;
    thumbnailSize?: number;
    thumbnailBorderWidth?: number;
    thumbnailBorderColor?: string;
    thumbnailsGap?: number;
    thumbnailsMarginRight?: number;
    thumbnailIconBackground?: string;
    activeArrows?: boolean;
    arrowStyle?: any;
    fullscreenByClick?: boolean;
    alternativeArrows?: boolean;
    isNotesGallery?: boolean;
  };
}

export interface GalleryItemProps {
  item: string;
  index: number;
  onPointerUp?: () => void;
  inFullScreen?: boolean;
  isNotesGallery?: boolean;
}

export interface GalleryThumbnailProps {
  item: string;
  active?: boolean;
  thumbnailsGap?: number;
  onPointerUp?: () => void;
  thumbnailIconBackground?: string;
  thumbnailBorderColor?: string;
  thumbnailSize?: number;
  isNotesGallery?: boolean;
  inFullScreen?: boolean;
}

export enum ArrowDirection {
  Left = 'left',
  Right = 'right',
}

export interface ArrowProps {
  className?: string;
  style?: any;
  onClick?: () => void;
  direction?: ArrowDirection;
}
